<style>
#scada {
  height: 84px;
}
.ol-popup {
  position: absolute;
  background-color: white;
  padding: 15px;
  border-radius: 10px;
  border: 1px solid #cccccc;
  bottom: 12px;
  left: -50px;
  width: auto;
}
.ol-popup:after,
.ol-popup:before {
  top: 100%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}
.ol-popup:after {
  border-top-color: white;
  border-width: 10px;
  left: 48px;
  margin-left: -10px;
}
.ol-popup:before {
  border-top-color: #cccccc;
  border-width: 11px;
  left: 48px;
  margin-left: -11px;
}
.popup__content > li {
  width: 240px;
  display: flex;
  justify-content: space-between;
}
.popup__content > li:not(:last-child) {
  border-bottom: 1px solid lightgrey;
}
</style>

<template>
  <vue-custom-scrollbar
    class="v-bar-element"
    v-bind:settings="{suppressScrollY : true}"
    ref="bar-element"
  >
    <div
      id="popup"
      class="ol-popup"
    >
      <div id="popup-content"></div>
    </div>
    <div class="group">
      <button
        class="ribbon-button"
        @click="chooseMarkerPosition"
      >
        <span class="icon">
          <v-icon>add_circle</v-icon>
        </span>
        <span class="caption">Dodaj punkt pomiarowy</span>
      </button>
    </div>
    <div class="group">
      <button
        class="ribbon-button"
        @click="show('scadaSettingsModal')"
      >
        <span class="icon">
          <v-icon>settings</v-icon>
        </span>
        <span class="caption">Ustawienia</span>
      </button>
    </div>
    <!-- <div class="group">
      <CommonComp/>
    </div> -->
    <div class="group">
      <span style="color: gray; line-height: 120px">Ostatnia aktualizacja danych: {{lastScadaUpdate}}</span>
    </div>
    <div
      class="more-hidden"
      id="showMore"
    >
      <a href="#">
        <span class="fa fa-ellipsis-h"></span>
      </a>
      <ul class="hidden-menu"></ul>
    </div>
    <AddScadaPoint
      :pointCoords="pointCoords"
      ref="childComponent"
      @newScadaPoint="addNewPoint"
    />
    <MeasuringPoint :featureProps="featureToPass" />
    <AddMeasuringSeries :pointID="pointID" />
    <ScadaPointCard :pointID="pointID" />
    <ScadaChart />
  </vue-custom-scrollbar>
</template>

<script>
// import CommonComp from "../../shared/CommonComp";
import AddScadaPoint from "./modals/AddScadaPoint";
import MeasuringPoint from "./modals/MeasuringPoint";
import ScadaPointCard from "./modals/ScadaPointCard";
import AddMeasuringSeries from "./modals/AddMeasuringSeries";
import ScadaChart from "./modals/ScadaChart";
import vueCustomScrollbar from "vue-custom-scrollbar";

import {click, pointerMove} from "ol/events/condition.js";
import Overlay from "ol/Overlay.js";
export default {
  components: {
    AddScadaPoint,
    AddMeasuringSeries,
    // CommonComp,
    MeasuringPoint,
    ScadaPointCard,
    ScadaChart,
    vueCustomScrollbar
  },
  data() {
    return {
      isClickable: false,
      pointCoords: undefined,
      pointCode: undefined,
      pointName: undefined,
      pointDescription: undefined,
      pointID: undefined,
      featureToPass: undefined,
      // scadaLoadTime: undefined,
      interval: undefined,

      //scadaPoints: [],
    };
  },
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    map() {
      return this.$store.getters.getMap;
    },
    scadaInterval() {
      return this.$store.getters.getScadaInterval;
    },
    lastScadaUpdate() {
      return this.$store.getters.getLastScadaUpdate;
    },

    scadaLayer() {
      return this.map
        .getLayers()
        .item(4)
        .getLayers()
        .item(5);
    },
  },
  watch: {
    scadaInterval() {
      this.cancelInterval();
      this.startInterval();
    }
  },
  methods: {
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    chooseMarkerPosition() {
      this.isClickable = true;
      document.getElementById("map").style.cursor = "crosshair";
      this.$root.$emit(
        "showSnackbar",
        "success",
        "Kliknij na mapie, aby dodać punkt pomiarowy"
      );
    },
    addNewPoint(value) {
      // props from AddScadaPoint component
      this.pointName = value.pointName;
      this.pointCode = value.pointCode;
      this.pointDescription = value.pointDescription;

      // creating new point and adding it to a source with all scada points
      this.$root.$emit("addNewScadaPoints", [value, this.pointCoords]);
    },
    startInterval(reset = true) {
      const self = this;
      self.refreshData(reset);
      this.interval = setInterval(() => {
        self.refreshData();
        // self.scadaLoadTime = new Date().toLocaleTimeString();
        self.$store.commit(
          "setScadaLastUpdate",
          new Date().toLocaleTimeString()
        );
      }, self.scadaInterval * 60 * 1000);
    },
    cancelInterval() {
      clearInterval(this.interval);
    },
    refreshData(reset = true) {
      const self = this;
      this.$store.dispatch("getScadaPoints").then(success => {
        if(success) {
          self.$root.$emit(
            "drawScadaPoints",
            self.$store.getters.getScadaPoints,
            reset
          );
          self.$root.$emit(
            "showSnackbar",
            "success",
            "Pomyślnie załadowano punkty pomiarowe"
          );
          self.$store.commit(
            "setScadaLastUpdate",
            new Date().toLocaleTimeString()
          );
        } else {
          self.$root.$emit(
            "showSnackbar",
            "red",
            "Podczas ładowania punktów pomiarowych wystąpił błąd"
          );
          self.scadaLoadTime = "Brak danych";
        }
      });
    },
    formatDate(date) {
      if(!date) {
        return null;
      } else {
        const [year, month, day] = date.split("-");
        return `${day}.${month}.${year}`;
      }
    }
  },
  mounted() {
    const self = this;
    let isScadaLoaded = false;

    let container = document.getElementById("popup");
    let content = document.getElementById("popup-content");
    let overlay = new Overlay({
      element: container,
      autoPan: true,
      autoPanAnimation: {
        duration: 250
      }
    });
    this.$root.$on('removeScadaPoint', overlay.setPosition(undefined));
    this.map.addOverlay(overlay);

    if ( ( this.$can("read", "scada_registry") || this.$can("edit", "scada_registry") ) ) {
      this.$root.$emit(
        "showSnackbar",
        "rgb(42, 87, 154)",
        "Trwa pobieranie informacji o punktach pomiarowych"
      );
    }
    this.startInterval(!!this.scadaLayer);

    this.map.on("singleclick", evt => {
      if(self.isClickable) {
        document.getElementById("map").style.cursor = "default";
        self.pointCoords = evt.coordinate;
        self.show("addScadaPointModal");
      }
      self.isClickable = false;
      let feature = self.map.forEachFeatureAtPixel(evt.pixel, feature => feature, {
        hitTolerance: 15,
        layerFilter: (layer) => layer === this.scadaLayer //wyszukujesz tylko z tej warstwy
      });
      if (feature) {
        if (
          !feature.get('symbol') &&
          !feature.get('item_alias')
        ) {
          overlay.setPosition(undefined);
          return;
        }
        let coordinates = feature.getGeometry().getCoordinates();
        overlay.setPosition(coordinates);
        if (feature.get('symbol')) {
          this.pointID = feature.get("pointID");
          content.innerHTML =
            `<ul class='popup__content'>\
            <li><span>Nazwa punktu</span> <span>${feature.get("name")}</span></li>\
            <li><span>Symbol punktu</span> <span>${feature.get("symbol")}</span></li>\
            <li><span>Ciśnienie</span> <span>${feature.get("pressure")}</span></li>\
            <li><span>Przepływ</span> <span>${feature.get("flow")}</span></li>\
            <li><span>Alarmy</span> <span>${feature.get("alarms")}</span></li>\
            <li class='font--primary'>
              <a id='scadaModalOpener'>Okno punktu pomiarowego</a>
            </li></ul>`;
          document
            .getElementById("scadaModalOpener")
            .addEventListener("click", () => {
              this.show("scadaPointCard");
              overlay.setPosition(undefined);
            });
        } else {
          let date = this.formatDate(feature.get("read_date").slice(0, 10));
          content.innerHTML =
            `<ul class='popup__content'>\
            <li><span>Numer seryjny</span> <span>${feature.get("serial_number")}</span></li>\
            <li><span>Adres</span> <span>${feature.get("address")}</span></li>\
            <li><span>Data ostatniego odzczytu</span> <span>${date}</span></li>\
            <li><span>Stan ostatniego odczytu [m3]</span> <span>${feature.get("read_value")}</span></li>\
            <li class='font--primary'>
              <a id='goToHydraNet' target='_blank' href='${this.hydranetUrl}${feature.get("item_alias")}'>Przejdź do systemu hydranet</a>
            </li></ul>`;
        }
      } else {
        overlay.setPosition(undefined);
        if(document.getElementById("scadaModalOpener")) {
          document
            .getElementById("scadaModalOpener")
            .removeEventListener("click", () => {
              this.show("scadaPointCard");
            });
        }
        return;
      }
    });
    },
    beforeDestroy() {
      this.cancelInterval();
      this.$root.$emit("clearScadaPoints");
    }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/scada/Scada.vue